import { useCallback, useReducer } from 'react';
import {
  SupplierInboundActionTypes,
  SupplierInboundItem,
  SupplierInboundState,
  supplierInboundReducer,
} from 'src/reducers/supplierInboundReducer';

const initialState: SupplierInboundState = {
  items: [],
};

export const useSupplierInbound = () => {
  const [state, dispatch] = useReducer(supplierInboundReducer, initialState);

  const addItem = useCallback((item: SupplierInboundItem) => {
    dispatch({
      type: SupplierInboundActionTypes.ADD_ITEM,
      payload: item,
    });
  }, []);

  const addItems = useCallback((items: SupplierInboundItem[]) => {
    dispatch({
      type: SupplierInboundActionTypes.ADD_ITEMS,
      payload: items,
    });
  }, []);

  const updateItem = useCallback((id: string, data: Partial<SupplierInboundItem>) => {
    dispatch({
      type: SupplierInboundActionTypes.UPDATE_ITEM,
      payload: { id, data },
    });
  }, []);

  const removeItem = useCallback((id: string) => {
    dispatch({
      type: SupplierInboundActionTypes.REMOVE_ITEM,
      payload: id,
    });
  }, []);

  const clearItems = useCallback(() => {
    dispatch({
      type: SupplierInboundActionTypes.CLEAR_ITEMS,
    });
  }, []);

  const setItems = useCallback((items: SupplierInboundItem[]) => {
    dispatch({
      type: SupplierInboundActionTypes.SET_ITEMS,
      payload: items,
    });
  }, []);

  return {
    items: state.items,
    addItem,
    addItems,
    updateItem,
    removeItem,
    clearItems,
    setItems,
  };
};

export default useSupplierInbound;
